"use strict";

exports.__esModule = true;
exports.caption = exports.body = exports.subheading = exports.heading3 = exports.heading2 = exports.heading1 = exports.hero = void 0;
var BREAKPOINTS = {
  tablet: 481,
  desktop: 996
};
var FONT_WEIGHT = {
  black: 900,
  bold: 700,
  medium: 500,
  demilight: 300
};

function hero(fontFace) {
  return "\nfont-family: " + fontFace + ";\nfont-size: 4rem;\nfont-weight: " + FONT_WEIGHT.black + ";\nline-height: 1.3;\n\n@media screen and (min-width: " + BREAKPOINTS.tablet + "px) {\n    font-size: 5rem;\n}";
}

exports.hero = hero;

function heading1(fontFace, round, fontFaceAccent) {
  if (round === void 0) {
    round = false;
  }

  if (fontFaceAccent === void 0) {
    fontFaceAccent = null;
  }

  return "\nfont-family: " + fontFace + ";\nfont-size: 3.2rem;\nfont-weight: " + FONT_WEIGHT.bold + ";\nline-height: 1.3;\n\n" + (round ? "\nfont-family: " + fontFaceAccent + ";\nfont-weight: 800;" : '') + "\n\n@media screen and (min-width: " + BREAKPOINTS.tablet + "px) {\n    font-size: 3.8rem;\n}";
}

exports.heading1 = heading1;

function heading2(fontFace, fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 700;
  }

  return "\nfont-family: " + fontFace + ";\nfont-size: 2.4rem;\nfont-weight: " + fontWeight + ";\nline-height: 1.3;\n\n@media screen and (min-width: " + BREAKPOINTS.tablet + "px) {\n    font-size: 2.8rem;\n}";
}

exports.heading2 = heading2;

function heading3(fontFace, fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = FONT_WEIGHT.bold;
  }

  return "\nfont-family: " + fontFace + ";\nfont-size: 2.1rem;\nfont-weight: " + fontWeight + ";\nline-height: 1.5;\n\n@media screen and (min-width: " + BREAKPOINTS.tablet + "px) {\n    font-size: 2.2rem;\n}";
}

exports.heading3 = heading3;

function subheading(fontFace, fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = FONT_WEIGHT.bold;
  }

  return "\nfont-family: " + fontFace + ";\nfont-size: 1.8rem;\nfont-weight: " + fontWeight + ";\nline-height: 1.5;";
}

exports.subheading = subheading;

function body(fontFace, fontSize, fontWeight) {
  if (fontSize === void 0) {
    fontSize = 1.6;
  }

  if (fontWeight === void 0) {
    fontWeight = FONT_WEIGHT.demilight;
  }

  return "\nfont-family: " + fontFace + ";\nfont-size: " + fontSize + "rem;\nfont-weight: " + fontWeight + ";\nline-height: 1.5;";
}

exports.body = body;

function caption(fontFace, fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = FONT_WEIGHT.demilight;
  }

  return "\nfont-family: " + fontFace + ";\nfont-size: 1.2rem;\nfont-weight: " + fontWeight + ";\nline-height: 1.5;";
}

exports.caption = caption;